import { z } from 'zod';
import { emailSchema } from './auth';
import { normalizarTelefone, telefoneValido } from './crm';
import { UFS } from './fiscal';
import { planoCodigoSchema } from './planos';

/** Tamanho da loja informado no cadastro (ajuda a equipe a sugerir o plano e a implantação). */
export const FAIXAS_CARROS = ['ate_20', '21_50', '51_100', 'mais_100'] as const;
export const NOME_FAIXA_CARROS: Record<(typeof FAIXAS_CARROS)[number], string> = {
  ate_20: 'Até 20 carros',
  '21_50': 'De 21 a 50 carros',
  '51_100': 'De 51 a 100 carros',
  mais_100: 'Mais de 100 carros',
};

/**
 * Cadastro da loja pelo site do sistema. Cria a loja só depois que o e-mail é confirmado.
 * `site` é um campo escondido (robôs preenchem) e `iniciadoEm` mede o tempo de preenchimento.
 */
export const cadastroLojaSchema = z.object({
  nomeLoja: z.string().trim().min(2, 'Informe o nome da loja').max(120),
  nome: z.string().trim().min(2, 'Informe seu nome').max(120),
  email: emailSchema,
  whatsapp: z
    .string()
    .trim()
    .refine((t) => telefoneValido(t), 'WhatsApp com DDD')
    .transform((t) => normalizarTelefone(t)!),
  cidade: z.string().trim().min(2, 'Informe a cidade').max(80),
  uf: z.enum(UFS, { error: 'Escolha o estado' }),
  carros: z.enum(FAIXAS_CARROS),
  plano: planoCodigoSchema,
  /** Módulos escolhidos para o teste (códigos) */
  modulos: z.array(z.string().trim().min(2).max(40)).max(10).optional(),
  aceite: z.literal(true, { error: 'Aceite os termos para continuar' }),
  site: z.string().max(200).optional(),
  iniciadoEm: z.number().int().optional(),
});
export type CadastroLojaInput = z.input<typeof cadastroLojaSchema>;

export const confirmarCadastroSchema = z.object({ token: z.string().min(20).max(200) });
